import React, { useState } from 'react';
import './InputBar.css';

function InputBar({ onSend, disabled = false }) {
  const [text, setText] = useState('');

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) handleSubmit();
  };

  return (
    <div className="input-bar">
      <input
        type="text"
        placeholder="How can I help you today?"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        aria-label="Ask LogicLine about the uploaded documents"
      />
      <button onClick={handleSubmit} disabled={disabled || !text.trim()} aria-label="Send message">➤</button>
    </div>
  );
}

export default InputBar;
